<template>
  <div class="character">
    <template v-if="character != null">
      <UserHeaderDesktop
        :characterName="character.characterName"
        :bdoClass="character.bdoClass"
        :familyName="character.familyName"
        :level="character.level"
        :guildName="character.guildName"
      />
      <v-row>
        <v-col cols="12" lg="9">
          <span
            class="pl-2 mt-5 mb-2 white--text font-weight-bold text-uppercase text-h3 d-inline-block"
            >Characters</span
          >
          <v-card class="pl-4 pr-4 pt-1 pb-1" dark>
            <v-row>
              <template v-for="(char, i) in character.characters">
                <v-col cols="12" md="6" lg="4" xl="4" :key="i" class="pa-0">
                  <CharacterCard
                    :bdoClass="char.bdoClass"
                    :level="char.level"
                    :characterName="char.characterName"
                    :key="i"
                  />
                </v-col>
              </template>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" lg="3">
          <span
            class="mt-5 mb-2 white--text font-weight-bold text-uppercase text-h3 d-inline-block"
            >Collection</span
          >
          <CollectionComponent />
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import UserHeaderDesktop from "@/components/UserHeaderDesktop.vue";
import CharacterCard from "@/components/CharacterCard.vue";
import CollectionComponent from "@/components/CollectionComponent.vue";
import axios from "axios";

export default {
  name: "Character",

  components: {
    UserHeaderDesktop,
    CharacterCard,
    CollectionComponent
  },
  data() {
    return {
      character: null
    };
  },
  mounted() {
    this.updateCharacter();
  },
  methods: {
    updateCharacter(characterName) {
      if (characterName === undefined) {
        characterName = this.$route.params.characterName;
      }
      axios
        .get("https://warflash.live/api/character?name=" + characterName)
        .then(response => (this.character = response.data));
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.updateCharacter(to.params.characterName);
    next();
  }
};
</script>

<style scoped>
</style>